"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function resolverTopRight(_a) {
    var trigger = _a.trigger, content = _a.content, viewport = _a.viewport;
    var left = trigger.rightUpAnchor.x - content.width;
    var top = trigger.rightUpAnchor.y;
    if (left > 0 && top + content.height <= viewport.height) {
        return {
            left: left,
            top: top,
        };
    }
    return false;
}
exports.default = resolverTopRight;
//# sourceMappingURL=resolverTopRight.js.map